import * as type from './type';
export default {
    [type.SET_PURCHASE_ORDER_DETAIL](state, purchaseOrderDetail) {
        state.purchaseOrderDetail = purchaseOrderDetail;
    },
    [type.SET_TAB_STATUS](state, tabStatus) {
        state.tabStatus = tabStatus;
    }
}


// WEBPACK FOOTER //
// ./src/store/purchase-order/mutations.js